export const colorsBackground = [
  '#F2C88C',
  '#D87846',
  '#6E3730',
  '#F2A760',
  '#A1560F',
  '#4B5907',
]

export const colorsFonts = [
  '#74694E',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
